export function createOnlineReadGuard() {
  let latest = 0;
  return {
    begin: () => ++latest,
    isCurrent: (id: number) => id === latest && navigator.onLine !== false,
  };
}
export async function purgeLegacyApiCache(
  storage: Pick<CacheStorage, 'delete'>,
  cacheName = 'sad5-api-v1',
): Promise<void> {
  await storage.delete(cacheName);
}
